import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { Team, InviteTeamPerson, ProfileTeamPerson, EditProfileTeamPerson } from './index';

export const TeamRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.TEAM} exact={true} component={Team} data-testid="TEAM" />
      <Route path={ROUTES.TEAM_INVITE_PERSON} component={InviteTeamPerson} />
      <Route path={ROUTES.TEAM_EDIT_PROFILE_PERSON} component={EditProfileTeamPerson} />
      <Route path={ROUTES.TEAM_PROFILE_PERSON} component={ProfileTeamPerson} />
    </Switch>
  );
}
